import {createSlice} from '@reduxjs/toolkit';
import {FormTagInit} from "./model";
const R = require('ramda');

const initialState = {
    tagForm: FormTagInit,
};

const tagSlice = createSlice({
    name: 'tag',
    initialState,
    reducers: {
        onTagFormChange: (state, action) => {
            const {name, value} = action.payload;
            state.tagForm[name] = value;
        },
        initTagForm: (state, action) => {
            state.tagForm = FormTagInit;
        },
        setCurrentTag: (state, action) => {
            state.tagForm = action.payload
        }
    },
});

export const {actions} = tagSlice;
export const {
    onTagFormChange,
    initTagForm,
    setCurrentTag
} = actions;

// reducers

// selectors

export const selTagForm = (state) => state.tag.tagForm;

const tagReducer = {
    tag: tagSlice.reducer,
};
export default tagReducer;
